module.exports = __webpack_public_path__ + "img/商城中国移动语音卡.aa9e2554.png";